import {RootLayout} from '@raison/ui-kit';
import React from 'react';

export default function OperationHeader({subtitle}: {subtitle?: React.ReactNode}) {
    return (
        <RootLayout.BaseHeader>
            <RootLayout.MenuButton />
            <hgroup className='flex flex-col items-center gap-1'>
                <RootLayout.TitleOutlet />
                {subtitle && <small className='fv-text-m-regular text-neutral-60'>{subtitle}</small>}
            </hgroup>
            <RootLayout.BackButton />
        </RootLayout.BaseHeader>
    );
}
